import { makeStyles } from '@material-ui/core/styles'
import { specialTheme, widthSM, widthXS } from '../theme'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: specialTheme.colors.white,
    fontSize: '1rem',
    minHeight: '80vh',
  },
  rootInsurance: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: specialTheme.colors.white,
    fontSize: '1rem',
    minHeight: '50vh',
  },
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    border: `3px solid ${specialTheme.colors.gray.warmGray}`,
    backgroundColor: specialTheme.colors.orange.light,
    maxWidth: specialTheme.layout.gridMainFormMaxWidth,
    // @ts-ignore
    // padding: specialTheme.layout.gridMainFormPadding,
    [theme.breakpoints.down(widthSM)]: {
      // @ts-ignore
      // padding: specialTheme.layout.gridMainFormPaddingDownWidthSM,
    },
  },
  overviewContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    border: `3px solid ${specialTheme.colors.gray.warmGray}`,
    backgroundColor: specialTheme.colors.orange.light,
    maxWidth: specialTheme.layout.gridMainFormMaxWidth,
    padding: '0 1.2rem 1.2rem 1.2rem',
    marginTop: '1.2rem',
    [theme.breakpoints.down(widthSM)]: {
      padding: '0 1.2rem 1.2rem 1.2rem',
    },
  },
  gridMainForm: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    maxWidth: specialTheme.layout.gridMainFormMaxWidth,
    backgroundColor: specialTheme.colors.white,
    padding: specialTheme.layout.gridMainFormPadding,
    [theme.breakpoints.down(widthSM)]: {
      padding: specialTheme.layout.gridMainFormPaddingDownWidthSM,
    },
  },
  gridMainFormInsurance: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    maxWidth: specialTheme.layout.gridMainFormMaxWidth,
    backgroundColor: specialTheme.colors.white,
    [theme.breakpoints.down(widthSM)]: {
      padding: specialTheme.layout.gridMainFormPaddingDownWidthSM,
    },
  },
  gridWorkArea: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    maxWidth: specialTheme.layout.gridWorkAreaMaxWidth,
    backgroundColor: specialTheme.colors.white,
    margin: specialTheme.layout.gridWorkAreaMargin,
    minHeight: specialTheme.layout.gridWorkAreaMinHeight,
    [theme.breakpoints.down(widthXS)]: {
      minHeight: specialTheme.layout.gridWorkAreaMinHeightDownWidthXS,
    },
  },
  gridWorkAreaInsurance: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    maxWidth: specialTheme.layout.gridMainFormMaxWidth,
    backgroundColor: specialTheme.colors.white,
    // margin: specialTheme.layout.gridWorkAreaMargin,
    // padding: specialTheme.layout.gridMainFormPadding,
    minHeight: specialTheme.layout.gridWorkAreaMinHeight,
    [theme.breakpoints.down(widthXS)]: {
      minHeight: specialTheme.layout.gridWorkAreaMinHeightDownWidthXS,
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  rowUpload: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  rowAlign: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'row',
    padding: specialTheme.layout.gridItemPadding,
    [theme.breakpoints.down(widthXS)]: {
      padding: specialTheme.layout.gridItemPaddingDownWidthXS,
    },
  },
  labelControl: {
    paddingTop: '0.5rem',
    paddingLeft: '1rem',
  },
  gridOverview: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: specialTheme.font.fontFSMe,
    padding: specialTheme.layout.gridOverviewPadding,
    [theme.breakpoints.down(widthXS)]: {
      padding: specialTheme.layout.gridOverviewPaddingDownWidthXS,
    },
  },
  fieldBorder: {
    width: '100%',
    fontFamily: specialTheme.font.fontFSMe,
    border: `1px solid ${specialTheme.colors.gray.warmGray}`,
    padding: '0.5rem',
  },
  fieldSize: {
    fontFamily: specialTheme.font.fontFSMe,
    width: '100%',
  },
  rowUnderline: {
    display: 'flex',
    flexDirection: 'row',
    textDecoration: 'underline',
    fontWeight: 'bold',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  uploadFiles: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
  },
  formControl: {
    ':after': {
      content: ' *',
      fontSize: '1rem',
      fontWeight: 600,
      color: specialTheme.colors.dark,
    },
  },
  error: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: specialTheme.font.fontFSMe,
    color: specialTheme.colors.red,
    width: '100%',
    height: 30,
  },
  checkError: {
    color: specialTheme.colors.red,
    width: '100%',
    fontSize: '0.75rem',
    marginTop: theme.spacing(2),
    fontFamily: specialTheme.font.fontFSMe,
  },
  checkErrorOverview: {
    margin: theme.spacing(1),
    textAlign: 'center',
  },
  checkErrorBlock: {
    color: specialTheme.colors.red,
    width: '100%',
    fontSize: '0.8rem',
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  labelArray: {
    paddingBottom: theme.spacing(0.65),
  },
  marginLeft: {
    marginLeft: theme.spacing(1),
  },
  gridCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  gridButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: specialTheme.layout.gridButtonMargin,
  },
  gridResize: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  textAreaLabel: {
    marginBottom: '1rem',
  },
  textAreaClass: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '0 0 0.5rem 0',
    '& .MuiInput-root': {
      border: 0,
    },
    '& .MuiInputBase-root': {
      marginTop: 0,
    },
    '& .MuiInputBase-multiline': {
      border: '1px solid',
      padding: '0.8rem',
    },
  },
  text: {
    color: specialTheme.colors.darkRed,
    fontFamily: specialTheme.font.fontFSMe,
    fontSize: specialTheme.layout.gridTypographyTextFontSize,
    fontWeight: specialTheme.layout.gridTypographyTextFontWeight,
    [theme.breakpoints.down(widthXS)]: {
      fontSize: specialTheme.layout.gridTypographyTextFontSizeWidthXS,
    },
    letterSpacing: specialTheme.layout.gridTypographyTextLetterSpacing,
    margin: specialTheme.layout.gridTypographyTextMargin,
  },
  textOverview: {
    color: specialTheme.colors.darkRed,
    fontFamily: specialTheme.font.fontFSMe,
    fontSize: '1.3rem',
    fontWeight: specialTheme.layout.gridTypographyTextFontWeight,
    [theme.breakpoints.down(widthXS)]: {
      fontSize: specialTheme.layout.gridTypographyTextFontSizeWidthXS,
    },
    letterSpacing: specialTheme.layout.gridTypographyTextLetterSpacing,
    margin: specialTheme.layout.gridTypographyTextMargin,
  },
  textLabel: {
    color: specialTheme.colors.darkRed,
    fontFamily: specialTheme.font.fontFSMe,
    fontWeight: 500,
    letterSpacing: specialTheme.layout.gridTypographyTextLetterSpacing,
    margin: specialTheme.layout.gridTypographyTextMargin,
  },
  /*overviewLabel: {
    color: specialTheme.colors.darkRed,
    fontFamily: specialTheme.font.fontFSMe,
    fontWeight: 500,
    letterSpacing: specialTheme.layout.gridTypographyTextLetterSpacing,
    margin: specialTheme.layout.gridTypographyOverviewMargin,
  },*/
  centerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  centerRowOverview: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  loadCircle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '1rem',
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: specialTheme.font.fontFSMe,
    color: specialTheme.colors.white,
    backgroundColor: specialTheme.colors.gray.dark1,
    '&:hover': {
      backgroundColor: specialTheme.colors.gray.dark1,
    },
  },
  overviewBoxRoot: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    margin: specialTheme.layout.gridTypographyTextMargin,
    paddingLeft: 0,
    paddingRight: 0,
  },
  overviewBoxContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    border: `3px solid ${specialTheme.colors.gray.warmGray}`,
    marginLeft: '2rem',
    marginRight: '2rem',
  },
  defaultText: {
    whiteSpace: 'pre-line',
    fontSize: '1rem',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '0.8rem',
      paddingRight: '0.6rem',
      paddingLeft: '0.6rem',
    },
    fontFamily: specialTheme.font.fontFSMe,
    letterSpacing: 0.24,
    paddingLeft: '1.2rem',
    paddingRight: '1.2rem',
    margin: '1rem 0 1rem 0',
  },
  textStyle: {
    whiteSpace: 'pre-line',
    fontSize: '1rem',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '0.8rem',
      paddingRight: '0.6rem',
      paddingLeft: '0.6rem',
    },
    fontFamily: specialTheme.font.fontFSMe,
    letterSpacing: 0.24,
    paddingRight: '1.2rem',
    margin: '1rem 0 1rem 0',
  },
  /*  pdf: {
    fontFamily: 'FS-Me, Arial, sans-serif !important',
  },*/
  changeButton: {
    fontFamily: specialTheme.font.fontFSMe,
    color: specialTheme.colors.white,
    backgroundColor: specialTheme.colors.darkRed,
    '&:hover': {
      backgroundColor: specialTheme.colors.darkRed,
    },
    marginTop: '1rem',
    padding: '10px 20px',
    [theme.breakpoints.down(widthXS)]: {
      width: '100%',
      margin: '0 15px 0 0',
    },
    textTransform: 'initial',
    fontSize: '1rem',
    borderRadius: 0,
    height: 46,
    border: `1px solid ${specialTheme.colors.darkRed}`,
  },
  uploadButton: {
    fontFamily: specialTheme.font.fontFSMe,
    color: specialTheme.colors.white,
    backgroundColor: specialTheme.colors.darkRed,
    '&:hover': {
      backgroundColor: specialTheme.colors.darkRed,
    },
    marginTop: '1rem',
    padding: '0 60px',
    [theme.breakpoints.down(widthXS)]: {
      width: '100%',
      margin: '0 15px 0 0',
    },
    textTransform: 'initial',
    fontSize: '1rem',
    borderRadius: 0,
    height: 46,
    border: `1px solid ${specialTheme.colors.darkRed}`,
  },
  checkBox: {
    '& .MuiFormControlLabel-label': {
      fontWeight: 400,
    },
  },
  checkBoxesInRow: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    margin: '0.4rem',
  },
  radioButtons: {
    marginTop: '0.4em',
    '& .MuiFormControlLabel-label': {
      fontWeight: 400,
      lineHeight: '1.1em',
    },
  },
  /*paragraphText: {
    color: specialTheme.colors.dark,
    fontSize: '1rem',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '0.8rem',
      paddingRight: '0.6rem',
      paddingLeft: '0.6rem',
    },
    fontWeight: 600,
    fontFamily: specialTheme.font.fontFSMe,
    letterSpacing: 0.24,
    margin: '1.2rem 0 0 0',
  },*/
}))
